<template>
	<GmapMarker
		:position="location.position"
		:clickable="clickable"
		:options="{
			'location_id': location.location_id
		}"
		:icon="markerIcon"
		:opacity="opacity"
		@mouseover="$emit('mouseover')"
		@mouseout="$emit('mouseout')"
		@click="$emit('click', { location })"
	/>
</template>

<script>
import { mapGetters } from "vuex"

export default {
	name: 'FlytMapMarker',

	props: {
		opacity: {
			type: [Number],
			default: 1
		},
		location: {
			type: Object
		},
		clickable: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		...mapGetters("bookingForm", ["aircraftCategory"]),

		// Icon object with image based on aircraft category
		markerIcon() {
			let marker = {
				scaledSize: { width: 36, height: 48 }
			}
			if (this.location.is_private) {
				marker.url = require("@/assets/flyt-icons_private-pin.svg")
				return marker
			}
			if (this.location.location_id === 0) {
				marker.url = require("@/assets/flyt-icons_area-pin.svg")
				return marker
			}
			if (this.aircraftCategory === 'aeroplane') {
				marker.url = require("@/assets/flyt-icons_airport-pin.svg")
				return marker
			}
			if (this.aircraftCategory === 'helicopter') {
				marker.url = require("@/assets/flyt-icons_helipad-pin.svg")
				return marker
			}
			return null
		},
	}
}
</script>
